module.exports = __webpack_public_path__ + "img/5.3087a6d8.jpg";